import React from "react";
import Skeleton from "react-loading-skeleton";

import ContentCardsSkeleton from "../../../Components/ContentCardsSkeleton/ContentCardsSkeleton";
import "../page-skeleton.css";

const skeletonColors = {
  baseColor: "var(--portal-skeleton-base)",
  highlightColor: "var(--portal-skeleton-highlight)",
};

const ContentListingPageSkeleton = () => (
  <div
    className="content-listing-page__inner portal-page-skeleton"
    aria-label="Carregando conteúdos"
    aria-busy="true"
  >
    <Skeleton
      {...skeletonColors}
      borderRadius={7}
      className="portal-page-skeleton__back"
    />

    <header className="portal-page-skeleton__header">
      <Skeleton
        {...skeletonColors}
        borderRadius={8}
        className="portal-page-skeleton__page-title"
      />
      <Skeleton
        {...skeletonColors}
        borderRadius={6}
        className="portal-page-skeleton__description"
      />
    </header>

    <Skeleton
      {...skeletonColors}
      borderRadius={8}
      className="portal-page-skeleton__listing-title"
    />
    <ContentCardsSkeleton count={6} showTitle={false} />
  </div>
);

export default ContentListingPageSkeleton;
